module.exports = __webpack_public_path__ + "img/star-sharp-half-stroke.e2378ddc.svg";